export const translationNotFound_en = {
  notFoundTitle: "Page not found",
  notFoundDescription:
    "The link may have changed or expired. Use the navigation or return to the dashboard home.",
  notFoundHomeLink: "Go to dashboard home",
};
